import * as React from 'react';
import omit from 'lodash/omit';
import TimeInterval, { Years, Days, Hours, Minutes, Seconds } from './TimeInterval';
export const UPDATE_INTERVAL = 500;
export default class CountdownTimer extends React.Component {
    constructor(props) {
        super(props);
        this.updateTimeRemaining = (props, time = UPDATE_INTERVAL) => {
            this.timer = window.setTimeout(() => {
                const timeRemaining = this.endTime - new Date().getTime();
                if (timeRemaining <= 0) {
                    typeof this.props.onExpiry === 'function' && this.props.onExpiry();
                }
                else {
                    if (typeof props.onTimeUpdate === 'function') {
                        props.onTimeUpdate(timeRemaining);
                    }
                    this.setState({ timeRemaining });
                    this.updateTimeRemaining(props);
                }
            }, time);
        };
        this.state = {
            timeRemaining: props.timeRemaining
        };
    }
    componentDidMount() {
        this.endTime = new Date().getTime() + this.props.timeRemaining;
        this.updateTimeRemaining(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.endTime = new Date().getTime() + nextProps.timeRemaining;
    }
    componentWillUnmount() {
        if (this.timer)
            window.clearTimeout(this.timer);
    }
    render() {
        return (<TimeInterval {...omit(this.props, ['children', 'timeRemaining', 'onExpiry', 'onTimeUpdate'])} interval={this.state.timeRemaining}>
				{this.props.children}
			</TimeInterval>);
    }
}
export { Years, Days, Hours, Minutes, Seconds };
